<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Predict Your Success</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#introduction">Introduction</a></li>
<li id="toc-li-4"><a href="#/text/ch004#how-to-use-this-book">How to Use This Book</a></li>
<li id="toc-li-5"><a href="#/text/ch005#part-i-discovery">Part I: Discovery</a>
<ol>
<li id="toc-li-6"><a href="#/text/ch006#the-journey-of-self-discovery">1: The Journey of Self-Discovery</a>
</li>
<li id="toc-li-12"><span href="#/text/ch007#more-precious-than-gold" title="Link target outside of Sample">2: More Precious Than Gold</span>
</li>
<li id="toc-li-14"><span href="#/text/ch008#graduate-from-want-to-need" title="Link target outside of Sample">3: Graduate from Want to Need</span>
</li>
<li id="toc-li-16"><span href="#/text/ch009#create-your-world" title="Link target outside of Sample">4: Create Your World</span></li>
<li id="toc-li-17"><span href="#/text/ch010#mind-your-mind" title="Link target outside of Sample">5: Mind Your Mind</span>
</li>
<li id="toc-li-27"><span href="#/text/ch011#change-your-focus" title="Link target outside of Sample">6: Change Your Focus</span>
</li>
<li id="toc-li-39"><span href="#/text/ch012#have-respect-for-time" title="Link target outside of Sample">7: Have Respect for Time</span>
</li>
</ol>
</li>
<li id="toc-li-49"><span href="#/text/ch013#part-ii-succeed" title="Link target outside of Sample">Part II: Succeed</span>
<ol>
<li id="toc-li-50"><span href="#/text/ch014#faith-is-a-must-have" title="Link target outside of Sample">8: Faith Is a Must-Have</span>
</li>
<li id="toc-li-63"><span href="#/text/ch015#commit-to-your-commitment" title="Link target outside of Sample">9: Commit to Your Commitment</span>
</li>
<li id="toc-li-70"><span href="#/text/ch016#fail-forward" title="Link target outside of Sample">10: Fail Forward</span>
</li>
<li id="toc-li-80"><span href="#/text/ch017#a-companion-of-eagles" title="Link target outside of Sample">11: A Companion of Eagles</span>
</li>
<li id="toc-li-83"><span href="#/text/ch018#move-things-around" title="Link target outside of Sample">12: Move Things Around</span>
</li>
<li id="toc-li-88"><span href="#/text/ch019#beautiful-imperfections" title="Link target outside of Sample">13: Beautiful Imperfections</span>
</li>
<li id="toc-li-95"><span href="#/text/ch020#press-the-reset-button" title="Link target outside of Sample">14: Press the Reset Button</span>
</li>
</ol>
</li>
<li id="toc-li-102"><span href="#/text/ch021#part-iii-perennial-success" title="Link target outside of Sample">Part III: Perennial Success</span>
<ol>
<li id="toc-li-103"><span href="#/text/ch022#create-a-continuous-improvement-plan" title="Link target outside of Sample">15: Create a Continuous
                Improvement Plan</span>
</li>
<li id="toc-li-109"><span href="#/text/ch023#beware-of-frenemies" title="Link target outside of Sample">16: Beware of Frenemies</span>
</li>
<li id="toc-li-115"><span href="#/text/ch024#pearls-diamonds" title="Link target outside of Sample">17: Pearls &amp; Diamonds</span>
</li>
<li id="toc-li-118"><span href="#/text/ch025#three-indispensable-virtues" title="Link target outside of Sample">18: Three Indispensable Virtues</span>
</li>
<li id="toc-li-122"><span href="#/text/ch026#complement-the-golden-goose" title="Link target outside of Sample">19: Complement the Golden Goose</span>
</li>
<li id="toc-li-123"><span href="#/text/ch027#carpe-diem" title="Link target outside of Sample">20: Carpe Diem</span></li>
</ol>
</li>
<li id="toc-li-124"><span href="#/text/ch028#bibliography" title="Link target outside of Sample">Bibliography</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?516cd6b5